import { z } from "zod";

export const grapesJsDataSchema = z.any();
